/**
 * Maps route paths to entity types for custom fields (SCMS modules).
 */
export const getEntityTypeFromRoute = (routePath: string): string | null => {
  const routeMap: Record<string, string> = {
    '/entities': 'Entity',
    '/suppliers': 'Entity',
    '/parameters/vessels': 'Vessel',
    '/crew': 'Crew',
    '/supplies/supply-cases': 'SupplyCase',
    '/supplies/requisitions': 'SupplyRequisition',
    '/supplies/supplier-enquiries': 'SupplierEnquiry',
    '/supplies/supplier-quotations': 'SupplierQuotation',
    '/supplies/supply-purchase-orders': 'SupplyPurchaseOrder',
    '/supplies/supply-deliveries': 'SupplyDelivery',
    '/supplies/supply-forwardings': 'SupplyForwarding',
    '/supplies/supply-invoices': 'SupplyInvoice',
    '/supplies/items': 'StoreItem',
    '/supplies/store-catalogs': 'StoreCatalog',
    '/accounting/journals': 'AccDocument',
    '/accounting/coa': 'AccAccount',
  };

  if (routeMap[routePath]) {
    return routeMap[routePath];
  }

  for (const [key, entityType] of Object.entries(routeMap)) {
    if (routePath.startsWith(key)) {
      return entityType;
    }
  }

  return null;
};

/**
 * Maps module title to entity type
 */
export const getEntityTypeFromTitle = (title: string): string | null => {
  const titleMap: Record<string, string> = {
    'Suppliers': 'Supplier',
    'Vessels': 'Vessel',
    'Crew': 'Crew',
    'Supply Cases': 'SupplyCase',
    'Supply Requisition': 'SupplyRequisition',
    'RFQ': 'SupplierEnquiry',
    'Quotations': 'SupplierQuotation',
    'Purchase Orders': 'SupplyPurchaseOrder',
    'Supply Deliveries': 'SupplyDelivery',
    'Supply forwardings': 'SupplyForwarding',
    'Supply Invoices': 'SupplyInvoice',
    'Store items': 'StoreItem',
    'Store catalogs': 'StoreCatalog',
    'Journals': 'AccDocument',
    'Chart of accounts': 'AccAccount',
  };

  return titleMap[title] || null;
};
